import { createSlice } from "@reduxjs/toolkit";

const userProfileSlice = createSlice({
    name: "userProfile",
    initialState: {
        pendingTasks: [],
        submittedTasks: [],
        shareSubmissions: [],
        totalPendingTasks: 0,
        totalSubmittedTasks: 0,
        totalShareSubmissions: 0,
    },
    reducers: {
        setPendingTasks: (state, action) => {
            state.pendingTasks = action.payload;
        },
        setSubmittedTasks: (state, action) => {
            state.submittedTasks = action.payload;
        },
        setShareSubmissions: (state, action) => {
            state.shareSubmissions = action.payload;
        },
        setPendingTasksCount: (state, action) => {
            state.totalPendingTasks = action.payload;
        },
        setSubmittedTasksCount: (state, action) => {
            state.totalSubmittedTasks = action.payload;
        },
        setShareSubmissionsCount: (state, action) => {
            state.totalShareSubmissions = action.payload;
        },
    },
});

export const { setPendingTasks, setSubmittedTasks, setShareSubmissions, setPendingTasksCount, setSubmittedTasksCount,setShareSubmissionsCount} = userProfileSlice.actions;

export default userProfileSlice.reducer;
